import useFacilityData from "../hooks/useFacilityData.ts"

export default () => {
  const data = useFacilityData()

  const testimonialArr = data.sanityFacility.facilityObj.testimonials

  return testimonialArr.length > 0
}